<template>
  <div class="b-basketball">
    <div class="view">
      <ul class="w">
        <div class="v-left v-dinglan">
          <a href="/lanqiu/wanchang" target="_blank">
            <li isview="0" class="v-li-1">完场比分</li>
          </a>
          <a href="/lanqiu/saicheng" target="_blank">
            <li isview="1" class="v-li-2">下日赛程</li>
          </a>
          <li isview="2" class="v-li-3 redBgc">完全版</li>
          <li isview="2" class="v-li-4">NBA版</li>
          <li isview="2" class="v-li-10">CBA版</li>
          <li isview="2" class="v-li-5 redBgc">按时间</li>
          <li isview="2" class="v-li-6 hide">按赛事</li>
          <li isview="2" class="v-li-7">
            已选择赛事 ∨
            <div class="down">
              <i class="iconfont guanbi">&#xe639;</i>
              <div class="d-up">已选择赛事</div>
              <div class="d-middle">
                <ul>
                  <li></li>
                </ul>
              </div>
              <div class="d-bottom">
                <div class="b-left">选中 <span>[0]</span>联赛</div>
                <div class="b-right">
                  <ul>
                    <li class="all-checked">全选</li>
                    <li class="reverse-checked">全不选</li>
                    <li class="sure-checked">确定</li>
                    <li class="cancel-checked">取消</li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li isview="2" class="v-li-8 redBgc returnChoose" @click="returnChoose()">
            完整<i></i>
          </li>
        </div>
        <div class="v-right v-dinglan">
          <!--<span class="v-lang" style="cursor: pointer;">
                            <i href="#" class="select-language zh">国语</i>
                            |
                            <i href="#" class="zht">粤语</i>
                        </span>-->
          <li class="v-li-11 view-lan">
            <span>语言选择</span>
            <div class="down">
              <div class="select-language zh">简体</div>
              <div class="zht">繁体</div>
            </div>
          </li>
          <li isview="2" class="v-li-9 view-sound">
            <i class="iconfont shengyin">&#xe638;</i>
            <span>默认</span>
            <div class="slidedown">
              <div class="d-main">
                <ul>
                  <li class="sound-0">静音</li>
                  <li class="sound-1">默认</li>
                  <li class="sound-2">撞击</li>
                </ul>
              </div>
            </div>
          </li>
        </div>
      </ul>
    </div>
    <div class="banner">
      <img :src="banner.img_url" @click="jumpFn(banner.jump_url)" />
    </div>
    <div class="basketball">
      <div id="loading">
        <img src="//static.fly2a.com/static/image/f-jiazai-min.png" class="jiazai" />
      </div>
      <div class="basketball-inner w" style="min-height: 605px">
        <div class="title">
          <div class="top_clear">
            <img src="//static.fly2a.com/static/image/2.basketball/grey_top_clear.png" alt="" />
          </div>
        </div>
        <div id="noListData" v-if="noListData">
          <img src="https://static.fly2a.com/gqj_tv/image/dianjing/noListData.png" alt="" />
        </div>
        <div class="baskClass fbClass b-top ings">
          <ul class="b-content fb-content"></ul>
        </div>
        <div class="baskClass fbClass b-fixed b-down ings ing" v-show="liIng != undefined && liIng.length > 0">
          <!--v-show="liIng!=undefined&&liIng.length>0"-->
          <img src="//static.fly2a.com/static/image/basketball_ing.png" alt="" />
          <ul class="b-content fb-content">
            <li v-for="$value in liIng" :data-id="$value.tournament_id" :data-ncaa="$value.league_id"
              :style="'display: ' + filterFn($value) + ';'">
              <div class="up">
                <div class="list_one" :data-eId="$value.league_id" style="display: none">
                  {{ $value.league_name_zh }}{{ $value.home_team_zh
                  }}{{ $value.away_team_zh }}
                </div>
                <!-- 左 -->
                <div class="table-left">
                  <div class="thead th-color1" style="background-color: #fbcaca">
                    <input type="checkbox" name="subCheckbox" :id="$value.tournament_id" />
                    <label :for="$value.tournament_id"></label>
                  </div>
                  <div class="tbody">
                    <span>{{ $value.start_time }}</span>
                  </div>
                </div>
                <!-- 中 -->
                <div class="table-middle">
                  <div class="thead">
                    <div class="w-1 th-color2" style="
                        color: red;
                        background: linear-gradient(
                          to right,
                          #fbcaca,
                          transparent
                        );
                      ">
                      <i :style="{ 'background-color': $value.color }"></i>
                      <span v-if="$value.league_name_zh" class="saishiName" :data-lang="$value.league_name_zh + ',' + $value.league_name_zht
            " v-html="$value.league_name_zh"></span>
                      <span v-else class="saishiName" :data-lang="$value.league_name_zh + ',' + $value.league_name_zht
            " v-html="$value.league_name_zh"></span>
                      <span class="changci">{{
            $value.league_id == 8
              ? $value.state_zh1
              : $value.state_zh
          }}</span>
                      <span v-if="$value.surplus_time != '00:00' &&
            $value.state != 50 &&
            $value.surplus_time != 0
            " class="countdown">{{ $value.surplus_time }}</span>
                      <span v-else class="countdown"></span>
                    </div>
                    <div v-if="$value.league_id == 8" class="w-2">
                      <span>上半场</span>
                      <span>下半场</span>
                      <span v-if="$value.away_overtime_one_score">OT</span>
                    </div>
                    <div v-else class="w-2">
                      <span>1</span>
                      <span>2</span>
                      <span>3</span>
                      <span>4</span>
                      <span v-if="$value.away_overtime_one_score">OT</span>
                    </div>
                    <div class="w-3">
                      <span>半场</span>
                      <span>全场</span>
                      <span>分差</span>
                      <span>总分</span>
                    </div>
                    <div class="w-4">欧赔</div>
                    <div class="w-5">让分盘</div>
                    <div class="w-6">大小分</div>
                  </div>
                  <div class="tbody">
                    <div class="tbody-two">
                      <div class="w-1" :data-lang="$value.home_team_zh + ',' + $value.home_team_zht
            ">
                        <a :href="'/lanqiu/gameteams?team_id=' + $value.home_team_id
            " target="_blank" class="pointer" :style="$value.home_rank
              ? 'max-width:108px;'
              : 'max-width:135px;'
            " v-html="$value.home_team_zh"></a>
                        <span>{{
            $value.home_rank ? "[" + $value.home_rank + "]" : ""
          }}</span>
                        <div class="rotate-sz">
                          <em>
                            <i class="iconfont">&#xe81e;</i>
                            <img src="/" alt="" class="rotate-img" style="display: none" />
                          </em>
                          <div class="god-anchor">
                            <div class="g-top">
                              <div class="g-top-left">
                                <div class="up">问路神针</div>
                                <p>幸运掌握在自己手中~</p>
                              </div>
                              <div class="g-top-right"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="$value.league_id == 8" class="w-2">
                        <span class="home_point1">{{
            $value.home_one_score
          }}</span>
                        <span class="home_point3">{{
              $value.home_three_score > 0
                ? $value.home_three_score
                : "-"
            }}</span>
                        <span v-if="$value.away_overtime_one_score" class="home_point5">{{
            $value.home_overtime_one_score +
            $value.home_overtime_two_score +
            $value.home_overtime_three_score
          }}</span>
                      </div>
                      <div v-else class="w-2">
                        <span class="home_point1">{{
              $value.home_one_score
            }}</span>
                        <span class="home_point2">{{
              $value.home_two_score > 0
                ? $value.home_two_score
                : "-"
            }}</span>
                        <span class="home_point3">{{
              $value.home_three_score > 0
                ? $value.home_three_score
                : "-"
            }}</span>
                        <span class="home_point4">{{
              $value.home_four_score > 0
                ? $value.home_four_score
                : "-"
            }}</span>
                        <span v-if="$value.away_overtime_one_score" class="home_point5">{{
            $value.home_overtime_one_score +
            $value.home_overtime_two_score +
            $value.home_overtime_three_score
          }}</span>
                      </div>
                      <div v-if="$value.league_id == 8" class="w-3">
                        <span v-if="$value.home_three_score == 0" class="home_half">{{ $value.home_one_score }}/-</span>
                        <span v-else class="home_half">{{ $value.home_one_score }}/{{
            $value.home_three_score
          }}</span>
                        <span class="home_all" style="color: #3393ff; font-weight: bold">{{ $value.home_score }}</span>
                        <span><em>半:</em><i class="half_fencha">{{
            $value.home_one_score - $value.away_one_score
          }}</i></span>
                        <span><em>半:</em><i class="half_zongfen">{{
              $value.home_one_score + $value.away_one_score
            }}</i></span>
                      </div>
                      <div v-else class="w-3">
                        <span v-if="$value.home_three_score == 0" class="home_half">{{
            $value.home_one_score + $value.home_two_score
          }}/-</span>
                        <span v-else class="home_half">{{
              $value.home_one_score + $value.home_two_score
            }}/{{
              $value.home_three_score + $value.home_four_score
            }}</span>
                        <span class="home_all" style="color: #3393ff; font-weight: bold">{{ $value.home_score }}</span>
                        <span><em>半:</em><i class="half_fencha">{{
            $value.home_one_score +
            $value.home_two_score -
            $value.away_one_score -
            $value.away_two_score
          }}</i></span>
                        <span><em>半:</em><i class="half_zongfen">{{
              $value.home_one_score +
              $value.home_two_score +
              $value.away_one_score +
              $value.away_two_score
            }}</i></span>
                      </div>
                      <em v-html="handleOddsFn($value.a, $value.b, $value.c, 2)">
                      </em>
                    </div>
                    <div class="tbody-one">
                      <div class="w-1" :data-lang="$value.away_team_zh + ',' + $value.away_team_zht
            ">
                        <!--'/lanqiu/gameteams?team_id='+$value.away_team_id-->
                        <a :href="'/lanqiu/gameteams?team_id=' + $value.away_team_id
            " target="_blank" class="pointer" :style="$value.away_rank
              ? 'max-width:108px;'
              : 'max-width:135px;'
            " v-html="$value.away_team_zh"></a>
                        <span>{{
            $value.away_rank ? "[" + $value.away_rank + "]" : ""
          }}</span>
                      </div>
                      <div v-if="$value.league_id == 8" class="w-2">
                        <span class="away_point1">{{
            $value.away_one_score
          }}</span>
                        <span class="away_point3">{{
              $value.away_three_score > 0
                ? $value.away_three_score
                : "-"
            }}</span>
                        <span v-if="$value.away_overtime_one_score" class="away_point5">{{
            $value.away_overtime_one_score +
            $value.away_overtime_two_score +
            $value.away_overtime_three_score
          }}</span>
                      </div>
                      <div v-else class="w-2">
                        <span class="away_point1">{{
              $value.away_one_score
            }}</span>
                        <span v-if="$value.away_two_score > 0" class="away_point2">{{ $value.away_two_score }}</span>
                        <span v-else class="away_point2">-</span>
                        <span v-if="$value.away_three_score > 0" class="away_point3">{{ $value.away_three_score
                          }}</span>
                        <span v-else class="away_point3">-</span>
                        <span v-if="$value.away_four_score > 0" class="away_point4">{{ $value.away_four_score }}</span>
                        <span v-else class="away_point4">-</span>
                        <span v-if="$value.away_overtime_one_score" class="away_point5">{{
            $value.away_overtime_one_score +
            $value.away_overtime_two_score +
            $value.away_overtime_three_score
          }}</span>
                      </div>
                      <div class="w-3">
                        <span v-if="$value.away_three_score == 0" class="away_half">{{
            $value.league_id == 8
              ? $value.away_one_score
              : $value.away_one_score + $value.away_two_score
          }}/-</span>
                        <span v-else class="away_half">{{
              $value.league_id == 8
                ? $value.away_one_score +
                "/" +
                $value.away_three_score
                : $value.away_one_score +
                $value.away_two_score +
                "/" +
                ($value.away_three_score + $value.away_four_score)
            }}</span>
                        <span class="away_all" style="color: #3393ff; font-weight: bold">{{
              $value.away_one_score +
              $value.away_two_score +
              $value.away_three_score +
              $value.away_four_score +
              $value.away_overtime_one_score +
              $value.away_overtime_two_score +
              $value.away_overtime_three_score
            }}</span>
                        <span v-if="$value.state >= 3" class="all_fencha"><em>总:</em><i>{{
            $value.home_one_score +
            $value.home_two_score +
            $value.home_three_score +
            $value.home_four_score +
            $value.home_overtime_one_score +
            $value.home_overtime_two_score +
            $value.home_overtime_three_score -
            $value.away_one_score -
            $value.away_two_score -
            $value.away_three_score -
            $value.away_four_score -
            ($value.away_overtime_one_score +
              $value.away_overtime_two_score +
              $value.away_overtime_three_score)
          }}</i></span>
                        <span v-else class="all_fencha"></span>
                        <span v-if="$value.state >= 3" class="all_zongfen"><em>总:</em><i>{{
            $value.home_one_score +
            $value.home_two_score +
            $value.home_three_score +
            $value.home_four_score +
            $value.home_overtime_one_score +
            $value.home_overtime_two_score +
            $value.home_overtime_three_score +
            $value.away_one_score +
            $value.away_two_score +
            $value.away_three_score +
            $value.away_four_score +
            $value.away_overtime_one_score +
            $value.away_overtime_two_score +
            $value.away_overtime_three_score
          }}</i></span>
                        <span v-else class="all_zongfen"></span>
                      </div>
                      <em v-html="handleOddsFn($value.a, $value.b, $value.c, 1)">
                      </em>
                    </div>

                  </div>
                </div>
                <!-- 右 -->
                <div class="table-right">
                  <div class="thead">
                    <div class="twoImg">
                      <a v-if="$value.is_tv" class="zhibo1" zhibo="1" target="_blank" :href="domainName +
            '/lanqiu/live?id=' +
            $value.tournament_id +
            '&zhibo=1'
            "><img src="//static.fly2a.com/static/image/zhibo.png" alt="" width="24" /></a>
                      <a v-else class="zhibo2" zhibo="0" target="_blank" :href="domainName +
            '/lanqiu/live?id=' +
            $value.tournament_id +
            '&zhibo=0'
            "><img src="//static.fly2a.com/static/image/zhibo2.png" alt="" width="24" /></a>&nbsp;
                      <i class="top-img iconfont icon-color-grey zhiding">&#xe618;</i>
                      &nbsp;
                      <i class="collect-img iconfont icon-color-grey no-shoucang">&#xe601;</i>
                      &nbsp;
                      <i class="collect-img iconfont icon-color-grey in-sound" style="font-size: 17px"
                        title="开启/关闭进球声音">&#xe6df;</i>
                    </div>
                  </div>
                  <div class="tbody">
                    <div class="t-up">
                      <span class="iszb" v-show="$value.is_zb" @mouseenter="zbshowFn($value.tournament_id)"
                        @mouseleave="zbshowFn($value.tournament_id, 1)">
                        <img src="//static.fly2a.com/static/image/microphone.png" />
                        <!--显示主播-->
                        <div class="zb_show" style="display: none"></div>
                      </span>
                      <span v-if="$value.recommend_id == 0" class="analyst"></span>
                      <span v-else class="analyst" :data-menId="$value.recommend_id" :data-anlId="$value.analyst_id"
                        :data-anlName="$value.analyst_name">
                        <img :src="$value.analyst_face" />
                      </span>
                      <a :href="'/lanqiu/shujufenxi?id=' + $value.tournament_id" target="_blank" class="pointer">析</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="detail">
                <span v-if="$value.remark" v-html="$value.remark"></span>
              </div>
              <div class="down" style="display: none">
                <div class="analyst-box" :recommend_id="$value.recommend_id"></div>
              </div>
            </li>
          </ul>
        </div>
        <div class="baskClass fbClass b-fixed b-down dont">
          <img src="//static.fly2a.com/static/image/basketball_dont.png" alt="" />
          <ul class="b-content fb-content">
            <li v-for="$value in liDont" :data-id="$value.tournament_id" :data-ncaa="$value.league_id"
              :style="'display: ' + filterFn($value) + ';'">
              <div class="up">
                <div class="list_one" :data-eId="$value.league_id" style="display: none">
                  {{ $value.league_name_zh }}{{ $value.home_team_zh
                  }}{{ $value.away_team_zh }}
                </div>
                <div class="table-left">
                  <div class="thead th-color1" style="background-color: #a1dafa">
                    <input type="checkbox" name="subCheckbox" :id="$value.tournament_id" />
                    <label :for="$value.tournament_id"></label>
                  </div>
                  <div class="tbody">
                    <span>{{ $value.start_time }}</span>
                  </div>
                </div>
                <div class="table-middle">
                  <div class="thead">
                    <div class="w-1 th-color2" style="
                        color: red;
                        background: linear-gradient(
                          to right,
                          #a1dafa,
                          transparent
                        );
                      ">
                      <i :style="{ 'background-color': $value.color }"></i>
                      <span class="saishiName" :data-lang="$value.league_name_zh + ',' + $value.league_name_zht
            " v-html="$value.league_name_zh"></span>
                      <span class="changci">未开赛</span>
                      <span class="countdown"></span>
                    </div>
                    <div v-if="$value.league_id == 8" class="w-2">
                      <span>上半场</span>
                      <span>下半场</span>
                    </div>
                    <div v-else class="w-2">
                      <span>1</span>
                      <span>2</span>
                      <span>3</span>
                      <span>4</span>
                    </div>
                    <div class="w-3">
                      <span>半场</span>
                      <span>全场</span>
                      <span>分差</span>
                      <span>总分</span>
                      <div class="god-anchor">
                        <div class="g-top">
                          <div class="g-top-left">
                            <div class="up">问路神针</div>
                            <p>幸运掌握在自己手中~</p>
                          </div>
                          <div class="g-top-right"></div>
                        </div>
                      </div>
                    </div>
                    <div class="w-4">欧赔</div>
                    <div class="w-5">让分盘</div>
                    <div class="w-6">大小分</div>
                  </div>
                  <div class="tbody">
                    <div class="tbody-two">
                      <div class="w-1" :data-lang="$value.home_team_zh + ',' + $value.home_team_zht
            ">
                        <a :href="'/lanqiu/gameteams?team_id=' + $value.home_team_id
            " target="_blank" class="pointer" :style="$value.home_rank
              ? 'max-width:108px;'
              : 'max-width:135px;'
            " v-html="$value.home_team_zh"></a>
                        <span>{{
            $value.home_rank ? "[" + $value.home_rank + "]" : ""
          }}</span>
                        <div class="rotate-sz">
                          <em>
                            <i class="iconfont">&#xe81e;</i>
                            <img src="" alt="" class="rotate-img" style="display: none" />
                          </em>
                          <div class="god-anchor">
                            <div class="g-top">
                              <div class="g-top-left">
                                <div class="up">问路神针</div>
                                <p>幸运掌握在自己手中~</p>
                              </div>
                              <div class="g-top-right"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="$value.league_id == 8" class="w-2">
                        <span class="home_point1">-</span>
                        <span class="home_point2">-</span>
                      </div>
                      <div v-else class="w-2">
                        <span class="home_point1">-</span>
                        <span class="home_point2">-</span>
                        <span class="home_point3">-</span>
                        <span class="home_point4">-</span>
                      </div>
                      <div class="w-3">
                        <span class="home_half">-/-</span>
                        <span class="home_all" style="color: rgb(51, 147, 255); font-weight: bold">-</span>
                        <span><em>半:</em><i class="half_fencha"></i></span>
                        <span><em>半:</em><i class="half_zongfen"></i></span>
                      </div>
                      <em v-html="handleOddsFn($value.a, $value.b, $value.c, 2, 1)
            ">
                      </em>
                    </div>
                    <div class="tbody-one">
                      <div class="w-1" :data-lang="$value.away_team_zh + ',' + $value.away_team_zht
            ">
                        <!--'/lanqiu/gameteams?team_id='+$value.away_team_id-->
                        <a :href="'/lanqiu/gameteams?team_id=' + $value.away_team_id
            " target="_blank" class="pointer" :style="$value.away_rank
              ? 'max-width:108px;'
              : 'max-width:135px;'
            " v-html="$value.away_team_zh"></a>
                        <span>{{
            $value.away_rank ? "[" + $value.away_rank + "]" : ""
          }}</span>
                      </div>
                      <div v-if="$value.league_id == 8" class="w-2">
                        <span class="away_point1">-</span>
                        <span class="away_point2">-</span>
                      </div>
                      <div v-else class="w-2">
                        <span class="away_point1">-</span>
                        <span class="away_point2">-</span>
                        <span class="away_point3">-</span>
                        <span class="away_point4">-</span>
                      </div>
                      <div class="w-3">
                        <span class="away_half">-/-</span>
                        <span class="away_all" style="color: #3393ff; font-weight: bold">-</span>
                        <span class="all_fencha"></span>
                        <span class="all_zongfen"></span>
                      </div>
                      <em v-html="handleOddsFn($value.a, $value.b, $value.c, 1, 1)
            ">
                      </em>
                    </div>

                  </div>
                </div>
                <div class="table-right">
                  <div class="thead">
                    <div class="twoImg">
                      <a v-if="$value.is_tv" class="zhibo1" zhibo="1" target="_blank" :href="domainName +
            '/lanqiu/live?id=' +
            $value.tournament_id +
            '&zhibo=1'
            "><img src="//static.fly2a.com/static/image/zhibo.png" alt="" width="24" /></a>
                      <a v-else class="zhibo2" zhibo="0" target="_blank" :href="domainName +
            '/lanqiu/live?id=' +
            $value.tournament_id +
            '&zhibo=0'
            "><img src="//static.fly2a.com/static/image/zhibo2.png" alt="" width="24" /></a>&nbsp;
                      <i class="top-img iconfont icon-color-grey zhiding">&#xe618;</i>
                      &nbsp;
                      <i class="collect-img iconfont icon-color-grey no-shoucang">&#xe601;</i>
                      &nbsp;
                      <i class="collect-img iconfont icon-color-grey in-sound" style="font-size: 17px"
                        title="开启/关闭进球声音">&#xe6df;</i>
                    </div>
                  </div>
                  <div class="tbody">
                    <div class="t-up">
                      <span class="iszb" v-show="$value.is_zb" @mouseenter="zbshowFn($value.tournament_id)"
                        @mouseleave="zbshowFn($value.tournament_id, 1)">
                        <img src="//static.fly2a.com/static/image/microphone.png" />
                        <!--显示主播-->
                        <div class="zb_show" style="display: none"></div>
                      </span>
                      <span v-if="$value.recommend_id == 0" class="analyst"></span>
                      <span v-else class="analyst" :data-menId="$value.recommend_id" :data-anlId="$value.analyst_id"
                        :data-anlName="$value.analyst_name"><img :src="$value.analyst_face" /></span>
                      <a :href="'/lanqiu/shujufenxi?id=' + $value.tournament_id" target="_blank" class="pointer">析</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="detail">
                <span v-if="$value.remark" v-html="$value.remark"></span>
              </div>
              <div class="down" style="display: none">
                <div class="analyst-box" :recommend_id="$value.recommend_id"></div>
              </div>
            </li>
          </ul>
        </div>
        <div class="baskClass fbClass b-fixed haved">
          <img src="//static.fly2a.com/static/image/basketball_haved.png" alt="" />
          <ul class="b-content fb-content">
            <li v-for="$value in liHaved" :data-id="$value.tournament_id" :data-ncaa="$value.league_id"
              :style="'display: ' + filterFn($value) + ';'">
              <div class="up">
                <div class="list_one" :data-eId="$value.league_id" style="display: none">
                  {{ $value.league_name_zh }}{{ $value.home_team_zh
                  }}{{ $value.away_team_zh }}
                </div>
                <!-- 左 -->
                <div class="table-left">
                  <div class="thead th-color1">
                    <input type="checkbox" name="subCheckbox" :id="$value.tournament_id" />
                    <label :for="$value.tournament_id"></label>
                  </div>
                  <div class="tbody">
                    <span>{{ $value.start_time }}</span>
                  </div>
                </div>
                <!-- 中 -->
                <div class="table-middle">
                  <div class="thead">
                    <div class="w-1 th-color2">
                      <i :style="{ 'background-color': $value.color }"></i>
                      <span v-if="$value.league_name_zh" class="saishiName" :data-lang="$value.league_name_zh + ',' + $value.league_name_zht
            " v-html="$value.league_name_zh"></span>
                      <span v-else class="saishiName" :data-lang="$value.league_name_zh + ',' + $value.league_name_zht
            " v-html="$value.league_name_zh"></span>
                      <span class="changci">{{
            $value.league_id == 8
              ? $value.state_zh1
              : $value.state_zh
          }}</span>
                      <span class="countdown"></span>
                    </div>
                    <div v-if="$value.league_id == 8" class="w-2">
                      <span>上半场</span>
                      <span>下半场</span>
                      <span v-if="$value.away_overtime_one_score">OT</span>
                    </div>
                    <div v-else class="w-2">
                      <span>1</span>
                      <span>2</span>
                      <span>3</span>
                      <span>4</span>
                      <span v-if="$value.away_overtime_one_score">OT</span>
                    </div>
                    <div class="w-3">
                      <span>半场</span>
                      <span>全场</span>
                      <span>分差</span>
                      <span>总分</span>
                    </div>
                    <div class="w-4">欧赔</div>
                    <div class="w-5">让分盘</div>
                    <div class="w-6">大小分</div>
                  </div>
                  <div class="tbody">
                    <div class="tbody-two">
                      <div class="w-1" :data-lang="$value.home_team_zh + ',' + $value.home_team_zht
            ">
                        <a :href="'/lanqiu/gameteams?team_id=' + $value.home_team_id
            " target="_blank" class="pointer" :style="$value.home_rank
              ? 'max-width:125px;'
              : 'max-width:165px;'
            " v-html="$value.home_team_zh"></a>
                        <span>{{
            $value.home_rank ? "[" + $value.home_rank + "]" : ""
          }}</span>
                        <!--<div class="rotate-sz">
													<em>
                                                        <i class="iconfont">&#xe81e;</i>
                                                        <img src="" alt="" class="rotate-img" style="display: none">
                                                    </em>
													<div class="god-anchor">
														<div class="g-top">
															<div class="g-top-left">
																<div class="up">问路神针</div>
																<p>幸运掌握在自己手中~</p>
															</div>
															<div class="g-top-right">
															</div>
														</div>
													</div>
												</div>-->
                      </div>
                      <div v-if="$value.league_id == 8" class="w-2">
                        <span class="home_point1">{{
            $value.home_one_score
          }}</span>
                        <span class="home_point3">{{
              $value.home_three_score > 0
                ? $value.home_three_score
                : "-"
            }}</span>
                        <span v-if="$value.away_overtime_one_score" class="home_point5">{{
            $value.home_overtime_one_score +
            $value.home_overtime_two_score +
            $value.home_overtime_three_score
          }}</span>
                      </div>
                      <div v-else class="w-2">
                        <span class="home_point1">{{
              $value.home_one_score
            }}</span>
                        <span class="home_point2">{{
              $value.home_two_score > 0
                ? $value.home_two_score
                : "-"
            }}</span>
                        <span class="home_point3">{{
              $value.home_three_score > 0
                ? $value.home_three_score
                : "-"
            }}</span>
                        <span class="home_point4">{{
              $value.home_four_score > 0
                ? $value.home_four_score
                : "-"
            }}</span>
                        <span v-if="$value.away_overtime_one_score" class="home_point5">{{
            $value.home_overtime_one_score +
            $value.home_overtime_two_score +
            $value.home_overtime_three_score
          }}</span>
                      </div>
                      <div v-if="$value.league_id == 8" class="w-3">
                        <span v-if="$value.home_three_score == 0" class="home_half">{{ $value.home_one_score }}/-</span>
                        <span v-else class="home_half">{{ $value.home_one_score }}/{{
            $value.home_three_score
          }}</span>
                        <span class="home_all" style="color: red; font-weight: bold">{{ $value.home_score }}</span>
                        <span><em>半:</em><i class="half_fencha">{{
            $value.home_one_score - $value.away_one_score
          }}</i></span>
                        <span><em>半:</em><i class="half_zongfen">{{
              $value.home_one_score + $value.away_one_score
            }}</i></span>
                      </div>
                      <div v-else class="w-3">
                        <span v-if="$value.home_three_score == 0" class="home_half">{{
            $value.home_one_score + $value.home_two_score
          }}/-</span>
                        <span v-else class="home_half">{{
              $value.home_one_score + $value.home_two_score
            }}/{{
              $value.home_three_score + $value.home_four_score
            }}</span>
                        <span class="home_all" style="color: red; font-weight: bold">{{ $value.home_score }}</span>
                        <span><em>半:</em><i class="half_fencha">{{
            $value.home_one_score +
            $value.home_two_score -
            $value.away_one_score -
            $value.away_two_score
          }}</i></span>
                        <span><em>半:</em><i class="half_zongfen">{{
              $value.home_one_score +
              $value.home_two_score +
              $value.away_one_score +
              $value.away_two_score
            }}</i></span>
                      </div>
                      <em v-html="handleOddsFn($value.a, $value.b, $value.c, 2)">
                      </em>
                    </div>
                    <div class="tbody-one">
                      <div class="w-1" :data-lang="$value.away_team_zh + ',' + $value.away_team_zht
            ">
                        <a :href="'/lanqiu/gameteams?team_id=' + $value.away_team_id
            " target="_blank" class="pointer" :style="$value.away_rank
              ? 'max-width:125px;'
              : 'max-width:165px;'
            " v-html="$value.away_team_zh"></a>
                        <span>{{
            $value.away_rank ? "[" + $value.away_rank + "]" : ""
          }}</span>
                      </div>
                      <div v-if="$value.league_id == 8" class="w-2">
                        <span class="away_point1">{{
            $value.away_one_score
          }}</span>
                        <span class="away_point3">{{
              $value.away_three_score > 0
                ? $value.away_three_score
                : "-"
            }}</span>
                        <span v-if="$value.away_overtime_one_score" class="away_point5">{{
            $value.away_overtime_one_score +
            $value.away_overtime_two_score +
            $value.away_overtime_three_score
          }}</span>
                      </div>
                      <div v-else class="w-2">
                        <span class="away_point1">{{
              $value.away_one_score
            }}</span>
                        <span v-if="$value.away_two_score > 0" class="away_point2">{{ $value.away_two_score }}</span>
                        <span v-else class="away_point2">-</span>
                        <span v-if="$value.away_three_score > 0" class="away_point3">{{ $value.away_three_score
                          }}</span>
                        <span v-else class="away_point3">-</span>
                        <span v-if="$value.away_four_score > 0" class="away_point4">{{ $value.away_four_score }}</span>
                        <span v-else class="away_point4">-</span>
                        <span v-if="$value.away_overtime_one_score" class="away_point5">{{
            $value.away_overtime_one_score +
            $value.away_overtime_two_score +
            $value.away_overtime_three_score
          }}</span>
                      </div>
                      <div class="w-3">
                        <span v-if="$value.home_three_score == 0" class="away_half">{{
            $value.league_id == 8
              ? $value.away_one_score
              : $value.away_one_score + $value.away_two_score
          }}/-</span>
                        <span v-else class="away_half">{{
              $value.league_id == 8
                ? $value.away_one_score +
                "/" +
                $value.away_three_score
                : $value.away_one_score +
                $value.away_two_score +
                "/" +
                ($value.away_three_score + $value.away_four_score)
            }}</span>
                        <span class="away_all" style="color: red; font-weight: bold">{{
              $value.away_one_score +
              $value.away_two_score +
              $value.away_three_score +
              $value.away_four_score +
              $value.away_overtime_one_score +
              $value.away_overtime_two_score +
              $value.away_overtime_three_score
            }}</span>
                        <span v-if="$value.state == -1" class="all_fencha"><em>总:</em><i>{{
            $value.home_one_score +
            $value.home_two_score +
            $value.home_three_score +
            $value.home_four_score +
            $value.home_overtime_one_score +
            $value.home_overtime_two_score +
            $value.home_overtime_three_score -
            $value.away_one_score -
            $value.away_two_score -
            $value.away_three_score -
            $value.away_four_score -
            ($value.away_overtime_one_score +
              $value.away_overtime_two_score +
              $value.away_overtime_three_score)
          }}</i></span>
                        <span v-else class="all_fencha"></span>
                        <span v-if="$value.state == -1" class="all_zongfen"><em>总:</em><i>{{
            $value.home_one_score +
            $value.home_two_score +
            $value.home_three_score +
            $value.home_four_score +
            $value.home_overtime_one_score +
            $value.home_overtime_two_score +
            $value.home_overtime_three_score +
            $value.away_one_score +
            $value.away_two_score +
            $value.away_three_score +
            $value.away_four_score +
            $value.away_overtime_one_score +
            $value.away_overtime_two_score +
            $value.away_overtime_three_score
          }}</i></span>
                        <span v-else class="all_zongfen"></span>
                      </div>
                      <em v-html="handleOddsFn($value.a, $value.b, $value.c, 1)">
                      </em>
                    </div>

                  </div>
                </div>
                <!-- 右 -->
                <div class="table-right">
                  <div class="thead">
                    <div class="twoImg">
                      <a v-if="$value.is_tv" class="zhibo1" zhibo="1" target="_blank" :href="domainName +
            '/lanqiu/live?id=' +
            $value.tournament_id +
            '&zhibo=1'
            "><img src="//static.fly2a.com/static/image/zhibo.png" alt="" width="24" /></a>
                      <a v-else class="zhibo2" zhibo="0" target="_blank" :href="domainName +
            '/lanqiu/live?id=' +
            $value.tournament_id +
            '&zhibo=0'
            "><img src="//static.fly2a.com/static/image/zhibo2.png" alt="" width="24" /></a>&nbsp;
                      <i class="top-img iconfont icon-color-grey zhiding">&#xe618;</i>
                      &nbsp;
                      <i class="collect-img iconfont icon-color-grey no-shoucang">&#xe601;</i>
                      &nbsp;
                      <i class="collect-img iconfont icon-color-grey in-sound" style="font-size: 17px"
                        title="开启/关闭进球声音">&#xe6df;</i>
                    </div>
                  </div>
                  <div class="tbody">
                    <div class="t-up">
                      <span class="iszb" v-show="$value.is_zb" @mouseenter="zbshowFn($value.tournament_id)"
                        @mouseleave="zbshowFn($value.tournament_id, 1)">
                        <img src="//static.fly2a.com/static/image/microphone.png" />
                        <!--显示主播-->
                        <div class="zb_show" style="display: none"></div>
                      </span>
                      <span v-if="$value.recommend_id == 0" class="analyst"></span>
                      <span v-else class="analyst" :data-menId="$value.recommend_id" :data-anlId="$value.analyst_id"
                        :data-anlName="$value.analyst_name">
                        <img :src="$value.analyst_face" />
                      </span>
                      <a :href="'/lanqiu/shujufenxi?id=' + $value.tournament_id" target="_blank" class="pointer">析</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="detail">
                <span v-if="$value.remark" v-html="$value.remark"></span>
              </div>

              <div class="down" style="display: none">
                <div class="analyst-box" :recommend_id="$value.recommend_id"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <lrFloat></lrFloat>
  </div>
</template>

<script>
import axios from "axios";
import lrFloat from "../components/LeftRightFloat";
import {
  showImg,
  saishiFunction,
  bianli_saishi,
  saishiClick,
  saishiLoading,
  dinglanClick,
  returnChoose,
  eventsHideNums,
  zhuanpan,
  roate_js,
  langChange,
  getLangChange,
  lanClick,
  lanComonFun,
  filterFn,
  dealItem,
} from "@/assets/js/b-filter";
import {
  eventFun,
  loadingChoose,
  goToTop,
  startLoad,
  collectFun,
  startLoad_collect,
  soundSwitch,
  startLoad_sound,
  goalSoundClick,
  goalSound,
} from "@/assets/js/b-basketball";
import { ws, leave } from "@/assets/js/ws-vue.js";
import {
  fbClass_recommend_ajax,
  postzan,
  analystEvent,
} from "@/assets/js/c-analyst.js";
var stateName = {
  0: "未开赛",
  1: "第一节",
  2: "第二节",
  3: "第三节",
  4: "第四节",
  5: "加时",
  6: "加时",
  7: "加时",
  "-1": "完场",
  "-2": "待定",
  "-3": "中断",
  "-4": "取消",
  "-5": "推迟",
  50: "中场",
};
//	var stateName = "比赛异常,未开赛,第一节,第一节完,第二节,第二节完,第三节,第三节完,第四节,加时,完场,中断,取消,延期,腰斩,待定".split(',');
//	var stateNameNcaa = "比赛异常,未开赛,上半场,'',下半场,上半场完,'',下半场完,第三节,加时,完场,中断,取消,延期,腰斩,待定".split(',');
var stateNameNcaa = {
  0: "未开赛",
  1: "上半场",
  3: "下半场",
  5: "加时",
  6: "加时",
  7: "加时",
  "-1": "完场",
  "-2": "待定",
  "-3": "中断",
  "-4": "取消",
  "-5": "推迟",
  50: "中场",
};
export default {
  components: {
    lrFloat,
  },
  data() {
    return {
      liIng: [],
      liIngArr: [],
      liDont: [],
      liDontArr: [],
      liHaved: [],
      liHavedArr: [],
      domainName: "",
      zbshow_id: 0,
      zbshow: 0,
      banner: {
        jump_url: "#",
        img_url: "//static.fly2a.com/gqj_tv/banner.png",
      },
      noListData: 0,
      headCon: headCon(),
    };
  },

  created() {
    this.request("new/getbasketball_list", this.getList);
  },
  beforeMount() {
    var wx_login_t = this.$route.query.wx_login_t;
    if (wx_login_t) {
      var href = location.href;
      if (location.href.indexOf("&") == -1) {
        href = href.replace("?wx_login_t=" + wx_login_t, "");
      } else {
        href = href.replace("&wx_login_t=" + wx_login_t, "");
        href = href.replace("wx_login_t=" + wx_login_t + "&", "");
      }
      history.pushState("", "", href);
    }
    this.domainName = COMMOND.DOMAIN_NAME;
  },
  mounted() {
    $(".haed_lanqiu").addClass("nuxt-link-exact-active");
    leave(this.reloadList);
    //			setTimeout(function(){
    //				axios.post(COMMOND.NEW_BASE_URL + 'add_sta','type=1&page=lanqiu&device=pc');
    //
    //				window.addEventListener('beforeunload', function() {
    //				  axios.post(COMMOND.NEW_BASE_URL + 'add_sta','type=2&page=lanqiu&device=pc');
    //				});
    //			},1000)
  },
  methods: {
    returnChoose,
    fbClass_recommend_ajax,
    postzan,
    eventsHideNums,
    roate_js,
    langChange,
    goalSound,
    loadingChoose,
    startLoad_collect,
    bianli_saishi,
    saishiLoading,
    showImg,
    lanComonFun,
    filterFn,
    request(url, fn, type) {
      url = COMMOND.NEW_BASE_URL + url;
      axios.get(url).then((res) => {
        if (fn) {
          fn(res.data);
        }
      });
    },
    reloadList() {
      this.request("new/getbasketball_list", this.getNewList);
    },
    getNewList(data) {
      $("ul.b-content").html("");
      $("ul.b-content").empty();
      this.liIng = [];
      this.liDont = [];
      this.liHaved = [];
      this.liIngArr = [];
      this.liDontArr = [];
      this.liHavedArr = [];
      this.$nextTick(function () {
        this.list = data.data.map((item) => {
          item.start_time = this.$format(item.start_time_int, "HH:mm");
          return item;
        });
        var oddArr = undefined;
        for (var i = 0, ilen = this.list.length; i < ilen; i++) {
          this.list[i].state_zh = stateName[this.list[i].state]; //赛事状态数字转中文
          this.list[i].state_zh1 = stateNameNcaa[this.list[i].state]; //ncaa赛事状态数字转中文

          if (this.list[i].state >= 1 && this.list[i].state <= 7) {
            //秒转时分秒
            if (this.list[i].on_time) {
              this.list[i].on_time = formatSeconds(this.list[i].on_time);
            } else {
              this.list[i].on_time = "";
            }
          }

          function formatSeconds(value) {
            //秒转时分秒+
            var theTime = parseInt(value);
            var theTime1 = 0;
            if (theTime > 60) {
              theTime1 = parseInt(theTime / 60);
              theTime = parseInt(theTime % 60);
              if (theTime1 > 60) {
                theTime1 = parseInt(theTime1 % 60);
              }
            }
            if (parseInt(theTime) < 10) {
              var resultTime = "0" + parseInt(theTime);
            } else {
              var resultTime = "" + parseInt(theTime);
            }
            if (theTime1 > 0) {
              if (parseInt(theTime1) < 10) {
                resultTime = "0" + parseInt(theTime1) + ":" + resultTime;
              } else {
                resultTime = "" + parseInt(theTime1) + ":" + resultTime;
              }
            } else {
              resultTime = "00" + ":" + resultTime;
            }
            return resultTime;
          }

          oddArr = this.list[i].odds;
          if (oddArr) {
            //封盘
            for (var j = 0; j < 3; j++) {
              if (oddArr[j]) {
                //初 即 滚
                for (var k = 0, klen = oddArr[j].length; k < klen; k++) {
                  if (oddArr[j][k]) {
                    if (parseInt(oddArr[j][k][3]) == 1) {
                      oddArr[j][k] = ["", "封", "", "no", "no", "no"];
                    }
                  }
                }
              }
            }
          }
        }
        dealItem(this.list);
        var list = this.list;
        for (var i = 0; i < list.length; i++) {
          if (
            (list[i].state >= 1 && list[i].state <= 7) ||
            list[i].state == 50
          ) {
            this.liIngArr.push(list[i]);
            this.liIng.push(list[i]);
          } else if (list[i].state === 0) {
            this.liDontArr.push(list[i]);
          } else if (list[i].state >= -5 && list[i].state <= -1) {
            this.liHavedArr.push(list[i]);
          }
        }
      });
      this.$nextTick(function () {
        this.liDont = this.liDontArr;
        this.liHaved = this.liHavedArr;
        this.$nextTick(function () {
          loadingChoose(); //加载选中
          startLoad_collect(); //加载收藏
          startLoad(this.zbshowFn); //加载置顶
          saishiLoading();
          eventsHideNums();
          showImg();
          getLangChange(); //初始化调用语言
          startLoad_sound(); //开始加载声音
        });
      });
    },
    getAd(data) {
      if (data.code == 200) {
        var top = data.data.top;
        if (top && top.img_url) {
          this.banner = {
            jump_url: top.jump_url,
            img_url: top.img_url,
          };
        }
      }
    },
    jumpFn(jump_url) {
      if (jump_url && jump_url != "#") {
        window.open(jump_url);
      }
    },
    getList(data) {
      if (data.ad) {
        this.banner = {
          jump_url: data.ad.jump_url,
          img_url: data.ad.img_url,
        };
      }
      this.list = data.data.map((item) => {
        item.start_time = this.$format(item.start_time_int, "HH:mm");
        return item;
      });
      if (this.list.length == 0) {
        this.noListData = 1;
      } else {
        this.noListData = 0;
      }
      var oddArr = undefined;
      for (var i = 0, ilen = this.list.length; i < ilen; i++) {
        this.list[i].state_zh = stateName[this.list[i].state]; //赛事状态数字转中文
        this.list[i].state_zh1 = stateNameNcaa[this.list[i].state]; //ncaa赛事状态数字转中文

        if (this.list[i].state >= 1 && this.list[i].state <= 7) {
          //秒转时分秒
          if (this.list[i].on_time) {
            this.list[i].on_time = formatSeconds(this.list[i].on_time);
          } else {
            this.list[i].on_time = "";
          }
        }

        function formatSeconds(value) {
          //秒转时分秒+
          var theTime = parseInt(value);
          var theTime1 = 0;
          if (theTime > 60) {
            theTime1 = parseInt(theTime / 60);
            theTime = parseInt(theTime % 60);
            if (theTime1 > 60) {
              theTime1 = parseInt(theTime1 % 60);
            }
          }
          if (parseInt(theTime) < 10) {
            var resultTime = "0" + parseInt(theTime);
          } else {
            var resultTime = "" + parseInt(theTime);
          }
          if (theTime1 > 0) {
            if (parseInt(theTime1) < 10) {
              resultTime = "0" + parseInt(theTime1) + ":" + resultTime;
            } else {
              resultTime = "" + parseInt(theTime1) + ":" + resultTime;
            }
          } else {
            resultTime = "00" + ":" + resultTime;
          }
          return resultTime;
        }

        oddArr = this.list[i].odds;
        if (oddArr) {
          //封盘
          for (var j = 0; j < 3; j++) {
            if (oddArr[j]) {
              //初 即 滚
              for (var k = 0, klen = oddArr[j].length; k < klen; k++) {
                if (oddArr[j][k]) {
                  if (parseInt(oddArr[j][k][3]) == 1) {
                    oddArr[j][k] = ["", "封", "", "no", "no", "no"];
                  }
                }
              }
            }
          }
        }
      }
      dealItem(this.list);
      var list = this.list;
      for (var i = 0; i < list.length; i++) {
        if ((list[i].state >= 1 && list[i].state <= 7) || list[i].state == 50) {
          this.liIngArr.push(list[i]);
          this.liIng.push(list[i]);
        } else if (list[i].state === 0) {
          this.liDontArr.push(list[i]);
        } else if (list[i].state >= -5 && list[i].state <= -1) {
          this.liHavedArr.push(list[i]);
        }
      }
      var liIngLen = 0;
      var liDontLen = 0;
      if (this.liIngArr.length < 50) {
        liIngLen = this.liIngArr.length;
        liDontLen = 50 - liIngLen;
      } else {
        liIngLen = 50;
      }
      this.liIng = this.liIngArr.slice(0, liIngLen);
      this.liDont = this.liDontArr.slice(0, liDontLen);
      this.liHaved = this.liHavedArr.slice(0, 10);
      this.$nextTick(function () {
        $("#loading").hide();
        $("footer").show();
        var that = this;
        setTimeout(function () {
          that.loadAll();
        }, 300);
        analystEvent();
        dinglanClick();
        zhuanpan(); //幸运转盘
        lanClick(); //国语-粤语
        goalSoundClick(); //进球声音切换
        soundSwitch(); //声音开关
        startLoad_sound(); //开始加载声音
        eventFun();
        goToTop(this.zbshowFn); //置顶点击事件
        collectFun(); //收藏
        saishiClick(); //赛事选择点击事件
        showImg();
        saishiFunction();
        getLangChange(); //初始化调用语言
        ws("basketballlive"); //篮球即时比分
        ws("basketball_list"); //篮球即时盘口
        var params = this.getParams();
      });
    },
    zbshowFn(id, type) {
      if (
        !$("li[data-id=" + id + "] .zb_show").text() &&
        !type &&
        !this.zbshow
      ) {
        this.zbshow = 1;
        $("li[data-id=" + id + "] .zb_show").html("");
        $("li[data-id=" + id + "] .zb_show").empty();
        var that = this;
        this.zbshow_id = id;
        this.request("get_anchors/" + id, getzblist);
        function getzblist(data) {
          if (data.data.length > 0 && that.zbshow_id == id) {
            for (var i = 0; i < data.data.length; i++) {
              var div =
                '<a class="zb_select" target="_blank" href="' +
                that.domainName +
                "/lanqiu/live?id=" +
                id +
                "&zhibo=1&tvid=" +
                data.data[i].tvid +
                '"><div><img src="' +
                data.data[i].face +
                '"></div><div class="tv_username">' +
                data.data[i].username +
                "</div></a>";
              $("li[data-id=" + id + "] .zb_show").append(div);
            }
            $("li[data-id=" + id + "] .zb_show").css("display", "block");
          }
          that.zbshow = 0;
        }
      }
      if (type) {
        this.zbshow_id = 0;
        $("li[data-id=" + id + "] .zb_show").css("display", "none");
        $("li[data-id=" + id + "] .zb_show").html("");
        $("li[data-id=" + id + "] .zb_show").empty();
      }
    },
    handleOddsFn(a, b, c, type, index) {
      var odds = {};
      var div = "";
      if (c) {
        odds = JSON.parse(c);
      } else if (b) {
        odds = JSON.parse(b);
      } else if (a) {
        odds = JSON.parse(a);
      }
      if (!odds["1"]) {
        odds["1"] = ["", "", ""];
      }
      if (!odds["2"]) {
        odds["2"] = ["", "", ""];
      }
      if (!odds["3"]) {
        odds["3"] = ["", "", ""];
      }
      if (odds["1"].length == 0) {
        odds["1"] = ["", "", ""];
      }
      if (odds["2"].length == 0) {
        odds["2"] = ["", "", ""];
      }
      if (odds["3"].length == 0) {
        odds["3"] = ["", "", ""];
      }
      if (type == 1) {
        div = '<div class="w-4">';
        div += '<span class="flag iconfont">' + odds["2"][1] + "</span>";
        div += "</div>";
        div += '<div class="w-5">';
        if (odds["1"][0]) {
          if (odds["1"][0] < 0) {
            odds["1"][0] = Math.abs(odds["1"][0]);
          } else {
            odds["1"][0] = "";
          }
        }
        div += "<span>" + odds["1"][0] + "</span>";
        div += "<span>" + odds["1"][2] + "</span>";
        div += "</div>";
        div += '<div  class="w-6">';
        if (odds["3"][0]) {
          if (index) {
            div += "<span><i>小</i>" + odds["3"][0] + "</span>";
          } else {
            div += "<span><i>大</i>" + odds["3"][0] + "</span>";
          }
        } else {
          div += "<span></span>";
        }
        div += '<span class="flag iconfont">' + odds["3"][2] + "</span>";
        div += "</div>";
      } else {
        div = '<div class="w-4">';
        div += '<span class="flag iconfont">' + odds["2"][0] + "</span>";
        div += "</div>";
        div += '<div class="w-5">';
        if (odds["1"][0]) {
          if (odds["1"][0] < 0) {
            odds["1"][0] = "";
          }
        }
        div += "<span>" + odds["1"][0] + "</span>";
        div += "<span>" + odds["1"][1] + "</span>";
        div += "</div>";
        div += '<div  class="w-6">';
        if (odds["3"][0]) {
          if (index) {
            div += "<span><i>大</i>" + odds["3"][0] + "</span>";
          } else {
            div += "<span><i>小</i>" + odds["3"][0] + "</span>";
          }
        } else {
          div += "<span></span>";
        }
        div += '<span class="flag iconfont">' + odds["3"][1] + "</span>";
        div += "</div>";
      }
      return div;
    },
    loadAll() {
      this.liIng = this.liIngArr.slice(0);
      this.liDont = this.liDontArr.slice(0);
      if (this.liDont.length > 200) {
        this.liHaved = this.liHaved.concat(this.liHavedArr.slice(10));
      } else {
        this.liHaved = this.liHaved.concat(this.liHavedArr.slice(10));
      }
      this.$nextTick(function () {
        loadingChoose(); //加载选中
        startLoad_collect(); //加载收藏
        startLoad(this.zbshowFn); //加载置顶
        saishiLoading();
        eventsHideNums();
        showImg();
        getLangChange(); //初始化调用语言
        startLoad_sound(); //开始加载声音
        //					if($("input:checkbox[id='CBA']").length == 0) {
        //						$('.v-li-10').attr("title", "暂无CBA赛事");
        //						$('.v-li-10').addClass("v-notcontent");
        //					} else {
        //						$('.v-li-10').attr("title", "");
        //						$('.v-li-10').removeClass("v-notcontent");
        //					}
        //					if($("input:checkbox[id='NBA']").length == 0) {
        //						$('.v-li-4').attr("title", "暂无NBA赛事");
        //						$('.v-li-4').addClass("v-notcontent");
        //					} else {
        //						$('.v-li-4').attr("title", "");
        //						$('.v-li-4').removeClass("v-notcontent");
        //					}
      });
    },
    getParams() {
      var data = window.location.search.replace("?", "");
      if (data) {
        data = data.split("&");
      }
      var obj = {};
      for (var i = 0; i < data.length; i++) {
        obj[data[i].split("=")[0]] = data[i].split("=")[1];
      }
      return obj;
    },
    tolink(id, that) {
      var el = that.currentTarget;
      var zhibo = $(el).attr("zhibo");
      window.open(domainName + "/lanqiu/live?id=" + id + "&zhibo=" + zhibo);
    },
    getCookie(name) {
      var arr = document.cookie.split("; ");
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("=");
        if (arr2[0] == name) {
          return arr2[1];
        }
      }
      return "";
    },
    togameteamslink(id) {
      window.open(
        window.location.protocol +
        "//" +
        window.location.host +
        "/lanqiu/gameteams?team_id=" +
        id
      );
    },
    toshujufenxilink(id) {
      window.open(
        window.location.protocol +
        "//" +
        window.location.host +
        "/lanqiu/shujufenxi?id=" +
        id
      );
    },
  },
  metaInfo() {
    return {
      title: this.headCon["lanqiu"]["title"],
      script: [
        {
          src: "//static.fly2a.com/static/js/jquery.rotate.min.js",
          ssr: false,
        },
      ],
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.headCon["lanqiu"]["description"],
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.headCon["lanqiu"]["keywords"],
        },
      ],
    };
  },
};
</script>

<style>
@import "../../assets/css/b-base.css";
@import "../../assets/css/b-basketball.css";
</style>
<style scoped="scoped">
.b-basketball .view ul .v-li-8 {
  visibility: inherit;
}

.view {
  height: 73px;
}

.view>ul {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.view>ul .v-left a li,
.view>ul .v-right a li {
  float: left;
  height: 38px;
  line-height: 38px;
  border: 1px solid #e24949;
  border-radius: 4px;
  color: #e24949;
  padding: 0 13px;
  cursor: pointer;
  margin-right: 10px;
}

.view>ul .v-left a li.v-active,
.view>ul .v-right a li.v-active {
  background: #e24949;
  color: #fff;
}

.view>ul .v-left>li,
.view>ul .v-right>li {
  float: left;
  height: 38px;
  line-height: 38px;
  border: 1px solid #e24949;
  border-radius: 4px;
  color: #e24949;
  padding: 0 13px;
  cursor: pointer;
  margin-right: 10px;
}

.view ul li.redBgc {
  background-color: #e24949;
  color: #fff;
  cursor: not-allowed;
}

.view>ul .v-left>li.v-active,
.view>ul .v-right>li.v-active {
  background: #e24949;
  color: #fff;
}

.view>ul .v-left>li.v-notcontent,
.view>ul .v-right>li.v-notcontent {
  color: #aaa;
  border-color: #999;
  cursor: not-allowed;
}

.view>ul .v-left>li.v-notcontent.v-active,
.view>ul .v-right>li.v-notcontent.v-active {
  background: #fff;
}

.view>ul .v-left>li.view-sound,
.view>ul .v-right>li.view-sound {
  width: 85px;
  height: 38px;
  color: #fff;
  background-color: #e24949;
  position: relative;
  border: 0;
  padding: 0 8px;
}

.view>ul .v-left>li.view-sound::after,
.view>ul .v-right>li.view-sound::after {
  content: "∨";
  display: inline-block;
  background-color: #cd4646;
  position: absolute;
  top: 0;
  right: 0;
  width: 25px;
  height: 38px;
  text-align: center;
  border-radius: 0 4px 4px 0;
}

.view>ul .v-left>li.view-sound i,
.view>ul .v-right>li.view-sound i {
  vertical-align: bottom;
}

.detail {
  background: linear-gradient(to right,
      #fbf9f9,
      #fbf9f9,
      transparent,
      transparent,
      transparent);
  margin-top: 1px;
}
</style>
<style type="text/css">
.b-basketball .basketball .baskClass ul li .review {
  margin-top: -2px;
}

.detail span {
  display: block;
  line-height: 20px;
  font-size: 12px;
  color: #989898;
  padding-left: 10px;
  position: relative;
}

.detail span::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 4px;
  background: #ff8d00;
  border-radius: 50%;
  position: absolute;
  left: 3px;
  top: 9px;
}
</style>